module.exports = __webpack_public_path__ + "img/celeb_demo.97b8f9e1.png";